import React from 'react';
import { Link } from 'react-router-dom';
import { Target } from 'lucide-react';

export const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
export const mesLabel = (ym) => (ym ? `${MESES[parseInt(ym.slice(5, 7), 10) - 1]} ${ym.slice(0, 4)}` : '');
export const mesCurto = (ym) => (ym ? MESES[parseInt(ym.slice(5, 7), 10) - 1].slice(0, 3) : '');
export const shiftMonth = (ym, d) => {
  const y = parseInt(ym.slice(0, 4), 10);
  const m = parseInt(ym.slice(5, 7), 10) - 1 + d;
  const dt = new Date(y, m, 1);
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
};

export const errMsg = (e, fb) => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : fb;
};
export const clampMeta = (v) => Math.min(1000, Math.max(0, parseInt(v, 10) || 0));

export const comercialUrl = (id) => `/comerciais/${id}/360`;

export const ComercialLink = ({ id, name, className = '', testId }) =>
  id ? (
    <Link to={comercialUrl(id)} onClick={(e) => e.stopPropagation()} data-testid={testId || `comercial-link-${id}`}
      className={`hover:text-[#4DD4E8] hover:underline ${className}`}>{name}</Link>
  ) : <span className={className}>{name}</span>;

export const MetaProgress = ({ meta, feitos, size = 'md', testId }) => {
  const pct = meta ? Math.min(100, Math.round((100 * feitos) / meta)) : 0;
  const color = !meta ? 'bg-slate-300' : pct >= 100 ? 'bg-emerald-500' : pct >= 60 ? 'bg-[#4DD4E8]' : pct >= 30 ? 'bg-amber-400' : 'bg-rose-500';
  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="flex items-baseline gap-2">
        <Target className={size === 'lg' ? 'w-6 h-6 text-[#4DD4E8]' : 'w-4 h-4 text-[#2D3E6F]'} />
        <span className={`font-bold font-[Outfit] ${size === 'lg' ? 'text-4xl' : 'text-2xl'}`}>{feitos}</span>
        <span className={size === 'lg' ? 'text-lg opacity-80' : 'text-sm text-slate-500'}>{meta ? `de ${meta} contratos` : 'contratos · sem meta definida'}</span>
        {meta > 0 && <span className={`ml-auto text-sm font-bold ${size === 'lg' ? '' : 'text-slate-700'}`}>{pct}%</span>}
      </div>
      <div className={`w-full rounded-full overflow-hidden ${size === 'lg' ? 'h-3 bg-white/15' : 'h-2.5 bg-slate-100'}`}>
        <div className={`h-full rounded-full ${color} transition-[width] duration-700`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};
